module.exports = __webpack_public_path__ + "static/conectionpeople-a195e2ae67edc7bf3b2d4eba26485299.png";